import { getDistanceUnit, getShortDistanceUnit, getWeightUnit } from '@/app/common/measures/measures.ts';
import type { PartialLocalization } from '@/app/common/measures/types.ts';
import { DISTANCE_UNITS, WEIGHT_UNITS } from '@/app/common/measures/types.ts';
import { convertToDifferentUnit } from '@/app/common/measures/converters.ts';
import { isShortDistance } from '@/app/common/measures/utility.ts';

export const getDistanceFromKm = (value: number, localization: PartialLocalization) => {
  const from = DISTANCE_UNITS.KM;
  const to = getDistanceUnit(localization.country);
  return convertToDifferentUnit(value, from, to, localization);
};

export const getDistanceFromM = (value: number, localization: PartialLocalization) => {
  const from = DISTANCE_UNITS.M;
  const isShort = isShortDistance(value, from);
  const to = isShort ? getShortDistanceUnit(localization.country) : getDistanceUnit(localization.country);
  return convertToDifferentUnit(value, from, to, localization);
};

export const getWeightFromKg = (value: number, localization: PartialLocalization) => {
  const from = WEIGHT_UNITS.KG;
  const to = getWeightUnit(localization.country);
  return convertToDifferentUnit(value, from, to, localization);
};
